import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import ReactEcharts from 'echarts-for-react';
import 'react-step-progress-bar/styles.css';
import {
  ProgressBar,
  Step
} from 'react-step-progress-bar';
import {
  saveScore
} from '../../actions/client';
import {
  RR_TEST,
} from '../../constants.js';
import TestResult from './TestResult';
import s from './RetirementRegret.css';
import cs from './common.css';

class RetirementRegret extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      qNum: 0,
      questions: [1,2,3,4,5,6],
      answers: Array.from({length: 6}),
    };
  }

  componentWillMount() {
    const panes = this.generateQuestions();
    this.setState(Object.assign({}, this.state, {
      panes: panes,
    }));
    this.getNextQuestion();
  }

  getNextQuestion() {
    let qNum = 7;
    // copy questions
    const questions = [].concat(this.state.questions);
    // if more questions get and remove one randomly
    if(questions.length > 0) {
      qNum = questions.shift();
    }
    // update the state with current num and remaining questions
    if(qNum === 7) {
      this.props.saveScore(RR_TEST, this.state.answers);
    }
    this.setState(Object.assign({}, this.state, {
      qNum: qNum,
      questions: questions,
    }));
  }

  answerQuestion = (params) => {
    const val = params.value === 1000 ? 0 : 1;
    // copy answers
    const answers = [].concat(this.state.answers);
    // set answer, get next question
    answers[this.state.qNum - 1] = val;
    this.setState(Object.assign({}, this.state, {
      answers: answers,
    }), () => {
      this.getNextQuestion();
    });
  }

  render() {
    const {
      qNum,
      questions,
      panes,
    } = this.state;
    if(qNum === 7) {
      return (
        <TestResult />
      );
    } else {
      let scrollBase = 1110;
      if (window.matchMedia('(max-device-width: 1200px)').matches) {
        scrollBase = 940;
      }
      if (window.matchMedia('(max-device-width: 992px) and (orientation: landscape)').matches) {
        scrollBase = 710;
      }
      if (window.matchMedia('(max-device-width: 992px) and (orientation: portrait)').matches) {
        scrollBase = 384;
      }
      if (window.matchMedia('((max-device-width : 414px)').matches) {
        scrollBase = 384;
      }
      if (window.matchMedia('(max-device-width : 375px)').matches) {
        scrollBase = 345;
      }
      if (window.matchMedia('(min-device-width : 768px) and (max-device-width : 1024px) and (-webkit-min-device-pixel-ratio: 2)').matches) {
        scrollBase = 738;
      }
      if (window.matchMedia('(min-device-width : 1024px) and (max-device-width : 1366px) and (-webkit-min-device-pixel-ratio: 2)').matches) {
        scrollBase = 994;
      }
      const ctrans = `translate(${-(((qNum - 1) * 30) + ((qNum - 1) * scrollBase))}px)`;
      return (
        <div>
          <div className="row">
            <div className="col-md-12">
              <div className={cs.headerRow}>
              <ProgressBar
                unfilledBackground="#BDC2C6"
                filledBackground="#35ccd2"
                height='1px'
                percent={100 / 5 * (5 - questions.length)}
              >
                <Step transition="scale">
                  {({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}
                </Step>
                <Step transition="scale">
                  {({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}
                </Step>
                <Step transition="scale">
                  {({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}
                </Step>
                <Step transition="scale">
                  {({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}
                </Step>
                <Step transition="scale">
                  {({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}
                </Step>
                <Step transition="scale">
                  {({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}
                </Step>
              </ProgressBar>
              </div>
              <div className={cs.headerTitle}>Present Bias</div>
            </div>
          </div>
          <div className="row">
            <div className={'col-md-12'} style={{overflow: 'hidden',paddingTop:'30px',paddingBottom:'30px'}}>
              <div className={cs.insidepane} style={{transform: ctrans}}>
                { panes }
              </div>
            </div>
          </div>
        </div>
      );
    }
  }

  generateQuestions() {
    const onEvents = {
      'click': this.answerQuestion,
    };
    const qCopy = 'Please choose which option you would prefer.';
    return (
      <div>
        <div className={cs.qpane + ' ' + cs.qpaneSize}>
          <div className={cs.question}>
            You just learned that you are due a tax refund.<br /><br />
            If you'd like, you can get the <strong>$1000 refund right away.</strong><br />
            Alternatively, you can get an <strong>$1100 refund in 10 months.</strong><br /><br />
          {qCopy}
          </div>
          <ReactEcharts onEvents={onEvents} option={ this.getChart(1000,1100,0,0) } style={{ height: 200 }} />
        </div>
        <div className={cs.qpane + ' ' + cs.qpaneSize}>
          <div className={cs.question}>
          You just learned that you are due a tax refund.<br /><br />
          If you'd like, you can get the <strong>$1000 refund in 18 months.</strong><br />
          Alternatively, you can get an <strong>$1100 refund in 28 months.</strong><br /><br />
          {qCopy}
          </div>
          <ReactEcharts onEvents={onEvents} option={ this.getChart(0,0,1000,1100) } style={{ height: 200 }} />
        </div>
        <div className={cs.qpane + ' ' + cs.qpaneSize}>
          <div className={cs.question}>
          You just learned that you are due a tax refund.<br /><br />
          If you'd like, you can get the <strong>$1000 refund right away.</strong><br />
          Alternatively, you can get an <strong>$1030 refund in 10 months.</strong><br /><br />
          {qCopy}
          </div>
          <ReactEcharts onEvents={onEvents} option={ this.getChart(1000,1030,0,0) } style={{ height: 200 }} />
        </div>
        <div className={cs.qpane + ' ' + cs.qpaneSize}>
          <div className={cs.question}>
          You just learned that you are due a tax refund.<br /><br />
          If you'd like, you can get the <strong>$1000 refund in 18 months.</strong><br />
          Alternatively, you can get an <strong>$1030 refund in 28 months.</strong><br /><br />
          {qCopy}
          </div>
          <ReactEcharts onEvents={onEvents} option={ this.getChart(0,0,1000,1030) } style={{ height: 200 }} />
        </div>
        <div className={cs.qpane + ' ' + cs.qpaneSize}>
          <div className={cs.question}>
          You just learned that you are due a tax refund.<br /><br />
          If you'd like, you can get the <strong>$1000 refund right away.</strong><br />
          Alternatively, you can get an <strong>$1300 refund in 10 months.</strong><br /><br />
          {qCopy}
          </div>
          <ReactEcharts onEvents={onEvents} option={ this.getChart(1000,1300,0,0) } style={{ height: 200 }} />
        </div>
        <div className={cs.qpane + ' ' + cs.qpaneSize}>
          <div className={cs.question}>
          You just learned that you are due a tax refund.<br /><br />
          If you'd like, you can get the <strong>$1000 refund in 18 months.</strong><br />
          Alternatively, you can get an <strong>$1300 refund in 28 months.</strong><br /><br />
          {qCopy}
          </div>
          <ReactEcharts onEvents={onEvents} option={ this.getChart(0,0,1000,1300) } style={{ height: 200 }} />
        </div>
      </div>
    );
  }

  getChart(now, ten, eighteen, twentyeight) {
    const labelTop = {
      show: true,
      fontSize:20,
      fontWeight:'bold',
      color:'#5b6770',
      position: 'top',
    };
    return {
      color: ['#84BD00'],
      grid: {
          top: '30',
          left: '3%',
          right: '8%',
          bottom: '3%',
          containLabel: true,
      },
      xAxis : [
        {
          type : 'category',
          data : ['Now','','','','','10 mon','','','','18 mon','','','','','28 mon'],
          axisLine: {
            lineStyle: {
                color: '#5b6770',
            },
          },
          axisLabel: {
            show: true,
            fontSize: 14,
          },
        },
      ],
      yAxis : [
        {
          type : 'value',
          max: 1500,
          axisLabel: {show: false},
          axisTick: {show: false},
          splitLine: {show: false},
          axisLine: {show: false},
        },
      ],
      series : [
        {
          type: 'bar',
          data: [
            {value: now, label: labelTop},
            0,0,0,0,
            {value: ten, label: labelTop},
            0,0,0,
            {value: eighteen, label: labelTop},
            0,0,0,0,
            {value: twentyeight, label: labelTop},
            ],
          label: {
            normal: {
              show: false,
              formatter: function (params) {
                const val = params.data.value;
                if(val === 0) {
                  return '';
                } else {
                  return '$' + val.toLocaleString();
                }
              },
            },
          },
        },
      ],
    };
  }
}

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, {
  saveScore,
})(RetirementRegret);



// WEBPACK FOOTER //
// ./src/components/ClientMode/RetirementRegret.js